import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { BillingService } from '../../../services/billing.service';

@Component({
  selector: 'ppl-claim-hierarchy',
  standalone: true,
  imports: [CommonModule, OrganizationChartModule],
  templateUrl: './claim-hierarchy.component.html',
  styleUrls: ['./claim-hierarchy.component.css'],
})
export class ClaimHierarchyComponent implements OnInit {
  chartData: TreeNode[] = [];
  @Input() hierarchyData: any;

  constructor(private billingService: BillingService) {}

  ngOnInit(): void {
    if (this.hierarchyData && Array.isArray(this.hierarchyData)) {
      this.chartData = this.buildOrgTree(this.hierarchyData);
    }
  }

  buildOrgTree(data: any[]): TreeNode[] {
    return data.map((item) => this.buildTreeNode(item));
  }

  buildTreeNode(item: any): TreeNode {
    return {
      label: item.adjustmentType || 'Claim',
      data: {
        createdDate: item.createdDate,
        adjustmentType: item.adjustmentType,
        statusDescription: item.statusDescription,
        timesheets: item.timesheets
          ? item.timesheets.replace(/[[\]]/g, '')
          : '',
        totalCharges: this.billingService.formatCurrency(item.totalCharges),
        paymentAmount: this.billingService.formatCurrency(item.paymentAmount),
        paymentDate: item.paymentDate,
        icn: item.icn,
        outstandingBalance: this.billingService.formatCurrency(
          item.outstandingBalance
        ),
      },
      expanded: true,
      children:
        item.adjustments?.map((child: any) => this.buildTreeNode(child)) || [],
    };
  }

  getNodeClass(type: string): string {
    if (!type) return '';
    switch (type.toLowerCase()) {
      case 'original claim':
        return 'original-claim';
      case 'adjustment claim':
        return 'adjustment-claim';
      case 'void claim (system generated)':
        return 'void-claim';
      case 'new claim':
        return 'new-claim';
      case 'amendment':
        return 'amendment';
      default:
        return 'default-claim';
    }
  }
}
